<template>
  <div footer>
    <div>
      <div class="wrapper">
        <a onclick="alert('준비중입니다')">이용약관</a>
        <a :href="asset('privatePolicy')" target="_blank">개인정보취급방침</a>
        <router-link :to="`/${site}/new/guide#contacts`">담당자찾기</router-link>
        <a @click="goAuthorityLink('wayToUs')">찾아오시는길</a>
        <div class="right">
          <select v-if="false">
            <option>주요기관홈페이지</option>
            <option value="http://naver.com">naver.com</option>
          </select>
          <select v-if="false">
            <option>주요기관홈페이지</option>
            <option value="http://naver.com">naver.com</option>
          </select>
          <a class="top" @click="goTop"></a>
        </div>
      </div>
    </div>
    <div>
      <div class="wrapper">
        <p>
          {{ asset('address') }}
          <span class="mh-10" v-if="asset('companyNo')">|</span>{{ asset('companyNo') }}
          <template v-if="site === 'kcl'">
            <span class="mh-10">|</span><router-link :to="`/${site}/new/guide#contacts`">담당자찾기</router-link>
          </template>
        </p>
        COPYRIGHT (C) 2018 {{ asset('name') }} KS 인증시스템. All RIGHT RESERVED
      </div>
    </div>
  </div>
</template>

<style lang="less">
  @import "../../../less/proj";

  [footer] {
    .wrapper { .w(1080); }
    > div:first-child { .h(60); background:#292929; font-size:0;
      a { .ib; .fs(14); .lh(60); color:#666; }
      a + a:before { content:'|'; .ib; .m(0,12); }
      .right { .fr;
        .top { .ib; .wh(50,60); .bg('@{common}/top.png'); }
        select { .fs(14); .lh(60); .h(60); color:#666; .pr(20); .mr(30); border:0; .bg('@{common}/footer-plus.png'); .no-repeat; background-position:  right center; }
      }
    }
    > div + div { .p(25,0,80); background:#222; color:#999;
      p { .fs(14,1.8); }
    }
  }
</style>

<script>
import $ from 'jquery';
import { getScrollBody } from '../../../utils';

export default {
  name: 'Footer',
  methods: {
    goTop() {
      $(getScrollBody()).animate({ scrollTop: 0 }, 300);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/front/common/AppFooter.vue